/*
 * Adds a subtle scroll-driven zoom to any element marked with
 * [data-scroll-zoom]. Scales its first <img> child from 1.0 (when the
 * element first enters the viewport from below) to 1 + amount (when the
 * element is about to exit at the top). Respects prefers-reduced-motion.
 *
 * Idempotent: safe to include the script multiple times.
 */
if (!window.__scrollZoomInit) {
  window.__scrollZoomInit = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scrollPending = false;

  function update() {
    scrollPending = false;
    const vh = window.innerHeight;
    const reduce = reducedMotion.matches;
    const elements = document.querySelectorAll('[data-scroll-zoom]');
    elements.forEach((el) => {
      const img = el.querySelector('img');
      if (!img) return;

      if (reduce) {
        img.style.transform = '';
        return;
      }

      const rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;

      const amount = parseFloat(el.dataset.scrollZoom || '0.05');
      const total = vh + rect.height;
      let progress = (vh - rect.top) / total;
      progress = Math.max(0, Math.min(1, progress));

      const scale = 1 + progress * amount;
      img.style.transform = `scale(${scale})`;
    });
  }

  function onScroll() {
    if (scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  reducedMotion.addEventListener('change', update);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
}
